import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _URL_TYPES_VS_TEKION_;

import { URL_TYPES } from '../../constants/api';
export var TEKION_SERVICES_VS_API_SERVICE = {
  DEFAULT: 'api',
  MEDIA: 'media',
  DSELITE: 'api/dselite',
  INTERNAL_SERVICE: 'internal-api',
  INTERNAL_SERVICE_DSE: 'internal-api/dselite'
};
export var URL_TYPES_VS_TEKION_SERVICES = (_URL_TYPES_VS_TEKION_ = {}, _defineProperty(_URL_TYPES_VS_TEKION_, URL_TYPES.CDMS, "".concat(TEKION_SERVICES_VS_API_SERVICE.DEFAULT)), _defineProperty(_URL_TYPES_VS_TEKION_, URL_TYPES.DSE, "".concat(TEKION_SERVICES_VS_API_SERVICE.DSELITE)), _defineProperty(_URL_TYPES_VS_TEKION_, URL_TYPES.TDP, ''), _defineProperty(_URL_TYPES_VS_TEKION_, URL_TYPES.MEDIA, "".concat(TEKION_SERVICES_VS_API_SERVICE.MEDIA)), _URL_TYPES_VS_TEKION_);